const mapOptional = <T>(value: T | undefined | null): T | undefined => {
    return value ?? undefined;
};

const mapYesNo = (value: boolean): 'y' | 'n' => {
    return value ? 'y' : 'n';
};

const mapObjectValues = <T extends object>(values: T | undefined): Array<T[keyof T]> => {
    return Object.values(values || {});
};

export const ValueHelpers = {
    mapOptional,
    mapYesNo,
    mapObjectValues,
};
